var _rect, _text, _text2, _g, _g2, _g3, _g4, _g5, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCase1Fig1VerificationTiers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1040 560",
    fontFamily: "Geist, 'Segoe UI', -apple-system, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1040,
    height: 560,
    fill: "#FFFDF7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 52,
    fontSize: 22,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Acceptance tiers, and which ones may move money")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 76,
    fontSize: 14,
    fill: "#4A5F56"
  }, "Every play is placed by what can honestly be verified about its result")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 118,
    width: 800,
    height: 112,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#16A34A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 152,
    fontSize: 17,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Machine"), /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 178,
    fontSize: 13.5,
    fill: "#4A5F56"
  }, "A pure-function reference oracle grades the submitted work against"), /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 197,
    fontSize: 13.5,
    fill: "#4A5F56"
  }, "hidden held-out cases. Settles with no credentials and no person."), /*#__PURE__*/React.createElement("text", {
    x: 820,
    y: 163,
    fontSize: 34,
    fontWeight: 700,
    fill: "#16A34A",
    textAnchor: "end",
    fontFamily: "'Geist Mono', Consolas, monospace"
  }, "263"), /*#__PURE__*/React.createElement("text", {
    x: 820,
    y: 185,
    fontSize: 12,
    fill: "#6B7F74",
    textAnchor: "end"
  }, "live plays"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 246,
    width: 800,
    height: 112,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#16A34A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 280,
    fontSize: 17,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "External"), /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 306,
    fontSize: 13.5,
    fill: "#4A5F56"
  }, "A verifiable predicate is checked against the outside world, for example"), /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 325,
    fontSize: 13.5,
    fill: "#4A5F56"
  }, "a deployed endpoint answering, or a dependency advisory count."), /*#__PURE__*/React.createElement("text", {
    x: 820,
    y: 291,
    fontSize: 34,
    fontWeight: 700,
    fill: "#16A34A",
    textAnchor: "end",
    fontFamily: "'Geist Mono', Consolas, monospace"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    x: 820,
    y: 313,
    fontSize: 12,
    fill: "#6B7F74",
    textAnchor: "end"
  }, "live plays"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 374,
    width: 800,
    height: 112,
    rx: 12,
    fill: "#F5F2E8",
    stroke: "#D4DDD6",
    strokeWidth: 1.5,
    strokeDasharray: "6 4"
  }), /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 408,
    fontSize: 17,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Human"), /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 434,
    fontSize: 13.5,
    fill: "#4A5F56"
  }, "Pure judgment, where no deterministic check reaches the answer."), /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 453,
    fontSize: 13.5,
    fill: "#4A5F56"
  }, "A person reviews it, and nothing settles automatically."), /*#__PURE__*/React.createElement("text", {
    x: 820,
    y: 419,
    fontSize: 18,
    fontWeight: 600,
    fill: "#6B7F74",
    textAnchor: "end"
  }, "no auto"), /*#__PURE__*/React.createElement("text", {
    x: 820,
    y: 441,
    fontSize: 12,
    fill: "#6B7F74",
    textAnchor: "end"
  }, "settlement"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M878 118 h18 v240 h-18",
    fill: "none",
    stroke: "#16A34A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 916,
    y: 222,
    fontSize: 13,
    fontWeight: 600,
    fill: "#16A34A"
  }, "settles with"), /*#__PURE__*/React.createElement("text", {
    x: 916,
    y: 240,
    fontSize: 13,
    fontWeight: 600,
    fill: "#16A34A"
  }, "no credentials"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 878,
    y1: 374,
    x2: 896,
    y2: 374,
    stroke: "#D4DDD6",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 916,
    y: 424,
    fontSize: 13,
    fill: "#6B7F74"
  }, "stays with"), /*#__PURE__*/React.createElement("text", {
    x: 916,
    y: 442,
    fontSize: 13,
    fill: "#6B7F74"
  }, "a person"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 524,
    fontSize: 13.5,
    fill: "#1A2F2A",
    fontWeight: 500
  }, "The constraint that places every play: no fallible signal may trigger irreversible money movement.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase1Fig1VerificationTiers);
export default __webpack_public_path__ + "static/media/case1-fig1-verification-tiers.818344f170e57ca7075dbf111092b4b5.svg";
export { ForwardRef as ReactComponent };